import { render, staticRenderFns } from "./waiting-room.vue?vue&type=template&id=6c303cc3&scoped=true&"
import script from "./waiting-room.ts?vue&type=script&lang=ts&"
export * from "./waiting-room.ts?vue&type=script&lang=ts&"
import style0 from "./waiting-room.scss?vue&type=style&index=0&id=6c303cc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c303cc3",
  null
  
)

export default component.exports